import { AxiosObj } from "../../Configurations/axios-setup";
import { fetchAccountId, fetchSubscriberId, fetchSubscriptionId } from "../../../utils/GetAccountDetails";
import axios from "axios";

class DpodAppFlyteApi {

    constructor() {
        this.accountId = null;
    }

    async initialize() {
        this.accountId = await fetchAccountId();
        this.subscriberId = await fetchSubscriberId()
        this.subscriptionId = await fetchSubscriptionId()
    }

    getUploadURLByPath = async (reqBody) => {
        await this.initialize();
        return AxiosObj.post(`/api/media/${this.accountId}/subscriber/${this.subscriberId}/subscription/${this.subscriptionId}/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/generate-upload-url-exact-path`, reqBody)
    }

    uploadFile = async (url, reqBody) => {
        return axios.post(url, reqBody)
    }

    getUploadedFileUrls = async (fileIds) => {
        await this.initialize();
        return AxiosObj.get(`/api/media/${this.accountId}/subscriber/${this.subscriberId}/subscription/${this.subscriptionId}/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/generate-upload-url?fileId=${fileIds}`)
    }

    getDownloadUrl = async (bucket_name, object_paths) => {
        await this.initialize();
        return AxiosObj.post(`/api/media/${this.accountId}/subscriber/${this.subscriberId}/subscription/${this.subscriptionId}/ameya-generate-download-url?bucket_name=${bucket_name}&object_paths=${object_paths}`)
    }

    deleteFolder = async (folderPath) => {
        await this.initialize();
        const encodedPath = encodeURIComponent(folderPath);
        return AxiosObj.delete(`/api/media/${this.accountId}/subscriber/${this.subscriberId}/subscription/${this.subscriptionId}/s3-folders/${encodedPath}`)
    }

}

const FilesApi = new DpodAppFlyteApi();
export default FilesApi;
